import { render, staticRenderFns } from "./ManageSavedMoney.vue?vue&type=template&id=a9b3f76c"
import script from "./ManageSavedMoney.vue?vue&type=script&lang=js"
export * from "./ManageSavedMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports